import { render, staticRenderFns } from "./ProformaEmision.vue?vue&type=template&id=e4e4fe18&scoped=true&"
import script from "./ProformaEmision.vue?vue&type=script&lang=js&"
export * from "./ProformaEmision.vue?vue&type=script&lang=js&"
import style0 from "./ProformaEmision.vue?vue&type=style&index=0&id=e4e4fe18&scoped=true&lang=css&"
import style1 from "./ProformaEmision.vue?vue&type=style&index=1&id=e4e4fe18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e4fe18",
  null
  
)

export default component.exports